import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { CartAndLineItemGroups } from '@/types/commercetools';
import { buildValidationRequest, parseValidationResponse } from '@/utility/couponValidation';
import { post } from '@/utility/requestHelpers/clientRequestHelpers';
import { useProductTypeCategoryIds } from './useProductTypeCategoryIds';

/**
 * Asks pricing-service which of the given coupons apply to the cart, and can be combined.
 * Returns the codes of the applied coupons. Re-validates whenever the cart version or the coupons
 * change. Failures are reported to Raygun by the global QueryCache error handler.
 */
export const useCouponValidation = (cartAndLineItemGroups, coupons) => {
  const $ = _c(18);
  let t0;
  if ($[0] !== cartAndLineItemGroups?.lineItemGroups) {
    t0 = cartAndLineItemGroups?.lineItemGroups.map(_temp) ?? [];
    $[0] = cartAndLineItemGroups?.lineItemGroups;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const shopIds = t0;
  const {
    categoryIdsByShop,
    isSuccess: categoriesLoaded
  } = useProductTypeCategoryIds(shopIds);
  let t1;
  if ($[2] !== coupons) {
    t1 = new Set(coupons);
    $[2] = coupons;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = [...t1];
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const uniqueCoupons = t2;
  const t3 = cartAndLineItemGroups?.cart.id;
  const t4 = cartAndLineItemGroups?.cart.version;
  let t5;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== uniqueCoupons) {
    t5 = ["couponValidation", t3, t4, uniqueCoupons];
    $[6] = t3;
    $[7] = t4;
    $[8] = uniqueCoupons;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== cartAndLineItemGroups || $[11] !== categoryIdsByShop || $[12] !== uniqueCoupons) {
    t6 = async () => {
      const request = buildValidationRequest({
        cartAndLineItemGroups,
        coupons: uniqueCoupons,
        categoryIdsByShop,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      return parseValidationResponse(await post("/api/v1/pricing/validation", request));
    };
    $[10] = cartAndLineItemGroups;
    $[11] = categoryIdsByShop;
    $[12] = uniqueCoupons;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = Boolean(cartAndLineItemGroups) && categoriesLoaded && uniqueCoupons.length > 0;
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = {
      queryKey: t5,
      queryFn: t6,
      enabled: t7,
      retry: 1
    };
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return useQuery(t8);
};
function _temp(group) {
  return group.shopId;
}